"use client";

import { Col, Container, Row } from "react-bootstrap";
import "./OdooChooseSection.scss";
import Image from "next/image";

const OdooChooseSection = ({ odooChoose }) => {
  if (!odooChoose) return null;

  const { title, description, features = [] } = odooChoose;

  return (
      <>
      <section className="odoo-choose-section">
        <Container>
          <h2 className="odoo-choose-title">
            {title}
          </h2>
          <p className="odoo-choose-description">
            {description}
          </p>

         <Row>
          <Col lg={12}>
            <div className="features-wrapper">
              <div className="feature-list">
                {features.map((item) => (
                  <div key={item.id} className="feature-row">
                    <div className="left-content">
                      <div className="feature-icon">
                        <Image
                          src={item.icon.src || item.icon}
                          alt="icon"
                          width={40}
                          height={40}
                        />
                      </div>
                      <p>{item.title}</p>
                    </div>

                    <div className="feature-image-container">
                      <Image
                        src={item.image}
                        alt="feature"
                        width={120}
                        height={80}
                        className="hover-zoom-img"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
        </Container>
      </section>
    </>
  );
};

export default OdooChooseSection;
